/**
 * ============================================================
 * BUSINESS REGISTRY
 * ============================================================
 * Maps URL slugs to their business config objects.
 *
 * URL pattern: /:slug  →  e.g. /hospital, /cafe, /gym
 *
 * To add a new business:
 *  1. Create src/config/businesses/myBusinessConfig.js
 *  2. Import it here
 *  3. Add an entry: mybusiness: myBusinessConfig
 * ============================================================
 */

import hospitalConfig    from "./businesses/hospitalConfig";
import cafeConfig        from "./businesses/cafeConfig";
import restaurantConfig  from "./businesses/restaurantConfig";
import gymConfig         from "./businesses/gymConfig";
import hotelConfig       from "./businesses/hotelConfig";
import salonConfig       from "./businesses/salonConfig";
import realestateConfig  from "./businesses/realestateConfig";
import schoolConfig      from "./businesses/schoolConfig";
import photographyConfig from "./businesses/photographyConfig";
import ngoConfig         from "./businesses/ngoConfig";
import itCompanyConfig   from "./businesses/itCompanyConfig";
import corporateConfig   from "./businesses/corporateConfig";
import ecommerceConfig   from "./businesses/ecommerceConfig";
import garbaConfig       from "./businesses/garbaConfig";

const businessRegistry = {
  hospital:    hospitalConfig,
  cafe:        cafeConfig,
  restaurant:  restaurantConfig,
  gym:         gymConfig,
  hotel:       hotelConfig,
  salon:       salonConfig,
  realestate:  realestateConfig,
  school:      schoolConfig,
  photography: photographyConfig,
  ngo:         ngoConfig,
  itcompany:   itCompanyConfig,
  corporate:   corporateConfig,
  ecommerce:   ecommerceConfig,
  garba:        garbaConfig,
};

export default businessRegistry;
